module.exports = __webpack_public_path__ + "static/instruction3.2ac23213.png";